// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"9fee549c","768":"356184da"}[chunkId] + ".chunk.js";
};